import Suspense from "components/shared/Suspense";
import Icon from "hardcover-ui/components/Icon";
import Button from "hardcover-ui/components/Button";
import { PageSerializersBooksLayout } from "types/serializers";
import faFlag from "icons/solid/flag.svg";
import faChevronDown from "icons/solid/chevron-down.svg";
import { useRef, useState } from "react";
import { Drawer } from "features/Drawer";
import ReportBookMenu from "./ReportBookMenu";

export interface Props {
  book: PageSerializersBooksLayout;
  onDuplicate: () => void;
}

export default function ReportBookButton({ book, onDuplicate }: Props) {
  const [open, setOpen] = useState(false);
  const portalRef = useRef<HTMLDivElement>();
  const buttonRef = useRef<HTMLButtonElement>();

  return (
    <div ref={portalRef}>
      <Button size="sm" variant="tertiary" className="gap-2" ref={buttonRef} onClick={() => setOpen(true)}>
        <Icon icon={faFlag} size="sm" className="fill-tertiary" />
        <span>Flag</span>
        <Icon icon={faChevronDown} size="sm" />
      </Button>


      {open && portalRef.current && buttonRef.current ? (
        <Suspense
          fallback={
            <Drawer.Loading
              settings={{
                portalRef: portalRef.current,
                ref: buttonRef.current,
                isOpen: true,
                onClose: () => {},
                placement: "bottom",
              }}
            />
          }
        >
          <Drawer
            settings={{
              portalRef: portalRef.current,
              ref: buttonRef.current,
              isOpen: true,
              onClose: () => setOpen(false),
              placement: "bottom",
            }}
          >
            <ReportBookMenu
              book={book}
              onDuplicate={() => { onDuplicate(); setOpen(false); }}
              onClose={() => setOpen(false)}
            />
          </Drawer>
        </Suspense>
      ) : (
        false
      )}
    </div>
  );
}
